<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />

        <action-button type="delete" @click="del(note.id)" v-if="note.id && modal != true" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <v-textarea
                  name="note"
                  v-model="note.note"
                  v-validate="'required'"
                  class="required-field"
                  :label="$t('participants.in_note')"
                  :error-messages="errors.collect('note')"
                  autocomplete="new-password"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "ParticipantInternalNoteForm",

  props: ["id", "participant_id", "modal"],

  data() {
    return {
      page_title: "",
      predata: {},
      note: {},
      dictionary: {
        attributes: {
          "note": this.$t("participants.in_note"),
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.note, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.page_title = this.$t("participants.in_new_title")
      this.predata = JSON.parse(JSON.stringify(this.note))
    } else {
      this.title = this.$t("participants.in_update_title")

      axios
        .get(this.API_URL + "participant/note/get/" + this.id)
        .then((res) => {
          this.note = res.data.data
          this.predata = JSON.parse(JSON.stringify(this.note))
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then((valid) => {
          if (valid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.note.id) {
              // Create
              axios
                .post(this.API_URL + "participant/note/create", {
                  participant_id: this.participant_id,
                  note: this.note.note,
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.note = res.data.data
                      vm.note = JSON.parse(JSON.stringify(vm.note))

                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "participant-note",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.page_title = this.$t("participants.in_update_note")
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "participant/note/update", {
                  id: this.note.id,
                  participant_id: this.participant_id,
                  note: this.note.note,
                })
                .then((res) => {
                  vm.note = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.note))

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "participant-note",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
  }
}
</script>

<style scoped></style>
